import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { LoginComponent } from './login/login.component'
import { ResetPasswordComponent } from './reset-password/reset-password.component'
import { SetPasswordComponent } from './set-password/set-password.component'
import { OneTimePasswordComponent } from './one-time-password/one-time-password.component'
import { VerifyPhoneNumberComponent } from './verify-phone-number/verify-phone-number.component'
import { ExpiredLinkComponent } from './expired-link/expired-link.component'
import { noAuthGuard } from '@core/guards/no-auth.guard'
import { CheckMobilePhoneComponent } from './check-mobile-phone/check-mobile-phone.component'
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component'
import { authGuard } from './auth.guard'

const authRoutes: Routes = [
  {
    path: 'login',
    canActivate: [noAuthGuard],
    component: LoginComponent,
  },
  {
    path: 'login/sso',
    canActivate: [noAuthGuard],
    component: LoginComponent,
  },
  {
    path: 'otp',
    canActivate: [noAuthGuard],
    component: OneTimePasswordComponent,
  },
  {
    path: 'reset-password',
    canActivate: [noAuthGuard],
    component: ResetPasswordComponent,
  },
  {
    path: 'set-new-password/:token',
    canActivate: [noAuthGuard],
    component: SetPasswordComponent,
  },
  {
    path: 'verify-phone/:token',
    canActivate: [noAuthGuard],
    component: VerifyPhoneNumberComponent,
  },
  {
    path: 'expired-link',
    canActivate: [noAuthGuard],
    component: ExpiredLinkComponent,
  },
  {
    path: 'check-mobile-phone',
    canActivate: [noAuthGuard],
    component: CheckMobilePhoneComponent,
  },
  {
    path: 'terms-of-use',
    canActivate: [authGuard],
    component: TermsOfUseComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
